module.exports = {
  en: {
    'HRES72UC0': {
      '0': 'Details of Med.Req.(2)',
      '10': 'Details of Med.Req.(2)',
      '20': 'Details of Med.Req',
      '30': 'Exp. Code',
      '40': 'Description',
      '50': 'Request Amount',
      '60': 'Approved Amount',
      '70': 'Total'
    },
    'HRES72UC1': {
      '0': '[HRES72U] Approval of Med.Exp. Request',
      '10': 'No.',
      '20': '[HRES72U] Approval of Med.Exp. Request',
      '30': 'Emp. Code',
      '40': 'Name',
      '50': 'Req. Date',
      '55': 'No.',
      '60': 'Req. Amount',
      '70': 'Approved Amount',
      '80': 'Status',
      '90': 'Approved by',
      '100': 'Appr. Date',
      '110': 'Remark',
      '120': 'Next Approve',
      '130': 'Payroll Group'
    },
    'HRES72UC2': {
      '0': 'Details Of Approve',
      '10': 'For Employee Code :',
      '20': 'Approved Level :',
      '30': 'Approved by :',
      '40': 'Date :',
      '50': 'Approved Amount :',
      '60': 'Voucher No. :',
      '70': 'Current Status :',
      '80': 'Status',
      '90': 'Approved',
      '100': 'Refused',
      '110': 'Remark :'
    },
    'HRES72UC3': {
      '10': 'History of Medical Exp.requisition',
      '20': 'Emp. Code',
      '30': 'Seq.',
      '40': 'Req. Date',
      '50': 'Treatment Period',
      '60': 'From Date',
      '70': 'To Date',
      '80': 'Hospital Code',
      '90': 'Type of Disease',
      '100': 'Type of Patient',
      '110': 'Amount',
      '120': 'Request',
      '130': 'Amount',
      '140': 'Approved'
    },
    'HRES72UC4': {
      '0': 'Details of Med.Req',
      '10': 'Details of Med.Req',
      '20': 'Requested Date',
      '30': 'Relation',
      '40': 'Name Patient',
      '50': 'Details of Treatment',
      '60': 'Treatment Period',
      '70': 'Hospital Name',
      '80': 'Type of Disease',
      '90': 'Type of Allowance',
      '100': 'With Delivery Notice',
      '110': 'Yes',
      '120': 'No',
      '130': 'Reference 1',
      '140': 'Reference 2',
      '150': 'Reference 3',
      '160': 'Req. Amount',
      '170': 'Start Date',
      '180': 'No. of Days',
      '190': 'Type of Payment',
      '200': 'By Cash',
      '210': 'By Payroll',
      '220': 'Remark',
      '230': 'Limit of Med. Allowance',
      '240': 'Type Patient'
    },
    'HRES72UC5': {
      '0': 'Med.exp Allowance',
      '10': 'Payment Condition',
      '20': 'Prorate for sv.yr< 1 yr.',
      '30': 'yes',
      '40': 'NO',
      '50': 'Type Of allowance',
      '60': 'Max.allow/ yr.',
      '70': 'Acc. Requested amt.',
      '80': 'Allowance',
      '90': 'Acc. Requested time',
      '100': 'No. of Req. Per Yr.'
    },
    'HRES72UC51': {
      '0': 'Payment Rate for IP.',
      '10': 'Payment Rate for IP.',
      '20': 'For Condition',
      '30': 'Med. Expense',
      '40': 'Unit',
      '50': 'Type of Hospital',
      '60': 'Allowance'
    },
    'HRES72UC6': {
      '10': 'Outstanding Allowance',
      '20': 'Type of Employee',
      '30': 'Relation',
      '40': 'Level',
      '50': 'Max. Allowance / Year',
      '60': 'Max. Allowance Per Case',
      '70': 'O.P.D (Amt./Case)',
      '80': 'I.P.D (% Reim.)',
      '90': 'Outstanding Allowance'
    },
    'HRES72UC7': {
      '10': 'Med. Reimburse Rate For I.P.D',
      '20': 'Type of Employee',
      '30': 'Relation',
      '40': 'Expense Code',
      '50': 'Type Of Clinic',
      '60': 'Normal',
      '70': 'Max. Limit',
      '80': '% Reimburse',
      '90': 'Emergency',
      '100': 'Max. Limit',
      '110': '% Reimburse'
    },
    'HRES72UC8': {
      '10': 'Outstanding Allowance',
      '20': 'Net Income',
      '30': 'Acc.request amt.',
      '40': 'Available',
      '50': 'Last req.date'
    },
    'HRES72UC9': {
      '10': 'Details of Med. Requisition',
      '20': 'Requested Date',
      '30': 'Relation',
      '40': 'Patient Name',
      '50': 'Details of Treatment',
      '60': 'Treatment Period',
      '70': 'Hospital Name',
      '80': 'Start Date',
      '100': 'No. of Days',
      '120': 'Type of Payment',
      '130': 'By Cash',
      '140': 'By Payroll',
      '150': 'With Delivery Notice',
      '160': 'Yes',
      '170': 'No',
      '180': 'Reference 1',
      '185': 'Remark',
      '190': 'Reference 2',
      '200': 'Reference 3',
      '210': 'Req. Amount',
      '220': 'Baht',
      '230': 'Days'
    }
  },
  th: {
    'HRES72UC0': {
      '0': 'รายละเอียดการเบิกค่ารักษาพยาบาล(2)',
      '10': 'รายละเอียดการเบิกค่ารักษาพยาบาล(2)',
      '20': 'รายละเอียดขอเบิกค่ารักษาพยาบาล',
      '30': 'รหัสค่ารักษา',
      '40': 'รายละเอียด',
      '50': 'จำนวนเงินขอเบิก',
      '60': 'จำนวนเงินที่เบิกได้',
      '70': 'รวมทั้งหมด'
    },
    'HRES72UC1': {
      '0': '[HRES72U] อนุมัติเบิกค่ารักษาพยาบาล',
      '10': 'ลำดับที่',
      '20': '[HRES72U] อนุมัติเบิกค่ารักษาพยาบาล',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'วันที่ขอ',
      '55': 'ลำดับที่',
      '60': 'ขอเบิก',
      '70': 'จำนวนเงินเบิกได้',
      '80': 'สถานะ',
      '90': 'ผู้อนุมัติ',
      '100': 'วันที่อนุมัติ',
      '110': 'หมายเหตุการอนุมัติ',
      '120': 'ผู้อนุมัติลำดับถัดไป',
      '130': 'กลุ่มการจ่ายเงินเดือน'
    },
    'HRES72UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน :',
      '20': 'ลำดับที่อนุมัติ :',
      '30': 'อนุมัติโดย :',
      '40': 'วันที่ :',
      '50': 'จำนวนเงินเบิกได้ :',
      '60': 'เลขที่ใบสำคัญ :',
      '70': 'สถานะปัจจุบัน :',
      '80': 'สถานะ',
      '90': 'อนุมัติ',
      '100': 'ไม่อนุมัติ',
      '110': 'หมายเหตุ :'
    },
    'HRES72UC3': {
      '10': 'ประวัติการเบิกค่ารักษา',
      '20': 'รหัสพนักงาน',
      '30': 'ลำดับที่',
      '40': 'วันที่ขอเบิก',
      '50': 'ระยะเวลาที่รักษา',
      '60': 'ตั้งแต่วันที่',
      '70': 'ถึงวันที่',
      '80': 'ชื่อสถานพยาบาล',
      '90': 'ประเภทโรค',
      '100': 'ประเภทคนไข้',
      '110': 'จำนวนเงิน',
      '120': 'ที่ขอ',
      '130': 'จำนวนเงิน',
      '140': 'ที่เบิกได้'
    },
    'HRES72UC4': {
      '0': 'รายละเอียดขอเบิกค่ารักษาพยาบาล',
      '10': 'รายละเอียดขอเบิกค่ารักษาพยาบาล',
      '20': 'วันที่ขอเบิก',
      '30': 'ความสัมพันธ์',
      '40': 'ชื่อผู้ป่วย',
      '50': 'รายละเอียดการรักษา',
      '60': 'ระยะเวลาการรักษา',
      '70': 'ชื่อสถานพยาบาล',
      '80': 'ประเภทโรค',
      '90': 'ประเภทวงเงิน',
      '100': 'มีใบส่งตัว',
      '110': 'มี',
      '120': 'ไม่มี',
      '130': 'เอกสารอ้างอิง 1.',
      '140': 'เอกสารอ้างอิง 2.',
      '150': 'เอกสารอ้างอิง 3.',
      '160': 'จำนวนเงินที่ขอเบิก',
      '170': 'วันที่เริ่มต้น',
      '180': 'จำนวนวัน',
      '190': 'ต้องการรับเงิน',
      '200': 'เงินสด',
      '210': 'จ่ายผ่านระบบเงินเดือน',
      '220': 'หมายเหตุ',
      '230': 'วงเงินการเบิก',
      '240': 'ประเภทผู้ป่วย'
    },
    'HRES72UC5': {
      '0': 'วงเงินค่ารักษาพยาบาล',
      '10': 'สำหรับเงื่อนไข',
      '20': 'คิดค่า Prolate',
      '30': 'คิด',
      '40': 'ไม่คิด',
      '50': 'ประเภทวงเงิน',
      '60': 'จำนวนเงินเบิกได้ต่อปี',
      '70': 'เบิกสะสม',
      '80': 'จำนวนเงินเบิกได้ต่อครั้ง',
      '90': 'ครั้งสะสม',
      '100': 'จำนวนครั้งเบิกได้ต่อปี'
    },
    'HRES72UC51': {
      '0': 'เงื่อนไขในการเบิกค่ารักษาพยาบาล',
      '10': 'เงื่อนไขในการเบิกค่ารักษาพยาบาล',
      '20': 'สำหรับเงื่อนไข',
      '30': 'ค่ารักษาพยาบาล',
      '40': 'หน่วย',
      '50': 'ประเภทสถานพยาบาล',
      '60': 'จำนวนเงินเบิกได้ต่อครั้ง'
    },
    'HRES72UC6': {
      '10': 'วงเงินค่ารักษาพยาบาล',
      '20': 'ประเภทพนักงาน',
      '30': 'ความสัมพันธ์',
      '40': 'ระดับ',
      '50': 'จำนวนเบิกสูงสุด/ปี',
      '60': 'วงเงินการเบิกค่ารักษา/ครั้ง',
      '70': 'คนไข้นอก (จนง.ต่อครั้ง)',
      '80': 'คนไข้ใน(% ตามอัตรา)',
      '90': 'วงเงินค่ารักษาคงเหลือ'
    },
    'HRES72UC7': {
      '10': 'เงื่อนไขการเบิกค่ารักษาพยาบาล',
      '20': 'ประเภทพนักงาน',
      '30': 'ความสัมพันธ์',
      '40': 'รหัสค่ารักษาพยาบาล',
      '50': 'ประเภทสถานพยาบาล',
      '60': 'ปกติ',
      '70': 'เบิกได้ต่อครั้ง',
      '80': '% ที่เบิกได้',
      '90': 'ฉุกเฉิน',
      '100': 'เบิกได้ต่อครั้ง',
      '110': '% ที่เบิกได้'
    },
    'HRES72UC8': {
      '10': 'วงเงินค่ารักษาคงเหลือ',
      '20': 'จำนวนเงินได้สุทธิ',
      '30': 'เบิกสะสม',
      '40': 'คงเหลือ',
      '50': 'วันที่เบิกครั้งสุดท้าย'
    },
    'HRES72UC9': {
      '10': 'รายละเอียดการรักษาพยาบาล(1)',
      '20': 'วันที่ขอเบิก',
      '30': 'ความสัมพันธ์',
      '40': 'ชื่อผู้ป่วย',
      '50': 'รายละเอียดการรักษา',
      '60': 'ระยะเวลาการรักษา',
      '70': 'ชื่อสถานพยาบาล',
      '80': 'วันที่เริ่มต้น1',
      '100': 'จำนวนวัน',
      '120': 'ต้องการรับเงิน1',
      '130': 'เงินสด1',
      '140': 'จ่ายผ่านระบบเงินเดือน',
      '150': 'มีใบส่งตัว1',
      '160': 'มี1',
      '170': 'ไม่มี1',
      '180': 'เอกสารอ้างอิง 1.1',
      '185': 'หมายเหตุ555',
      '190': 'เอกสารอ้างอิง 2.1',
      '200': 'เอกสารอ้างอิง 3.1',
      '210': 'จำนวนเงินที่ขอเบิก1',
      '220': 'บาท',
      '230': 'วัน'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres72u.js